import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { ViewerRightPanelComponent } from './viewer-right-panel.component';
import { MaskOpacityModule } from './mask-opacity/mask-opacity.module';
import { EditImageToolsModule } from '../edit-image-tools/edit-image-tools.module';
import { ProjectActionsModule } from './project-actions/project-actions.module';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MaskOpacityModule,
    TranslateModule,
    EditImageToolsModule,
    ProjectActionsModule,
  ],
  declarations: [ViewerRightPanelComponent],
  exports: [ViewerRightPanelComponent],
  providers: [],
})
export class ViewerRightPanelModule {}
